module.exports = __webpack_public_path__ + "static/media/phone.91c67e10.svg";